export default "__VITE_ASSET__dRkVWC2T__"